//import store from '../store/store.js'

//export function autenticado() {
//  return store.getters.isAuthenticated
//}

export function templates(autenticacao) {
  let templates = [
    {
      layer: 'sistema_rodoviario_lin_p31982',
      tab: 'Sistema Rodoviário',
      headers: [
        { text: 'Trecho', value: 'trecho' },
        { text: 'De', value: 'de' },
        { text: 'Para', value: 'para' },
        { text: 'Km Inicial', value: 'km_inicial' },
        { text: 'Km Final', value: 'km_final' },
        { text: 'Extensão (km)', value: 'extensao' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Responsável', value: 'resp' },
        { text: 'Escritório Regional', value: 'esc_regional' },
        { text: 'Jurisdição', value: 'jurisdicao' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Tipojuris', value: 'tipojuris' }
      ],
      items: []
    },
    {
      layer: 'escritorios_regionais_pol_p31982',
      tab: 'Escritórios Regionais',
      headers: [
        { text: 'Escritório Regional', value: 'esc_reg' },
        { text: 'Superintendência', value: 'sup' }
      ],
      items: []
    },
    {
      layer: 'municipios_pol_p31982',
      tab: 'Municípios',
      headers: [
        { text: 'Nome', value: 'nome' }
      ],
      items: []
    },
    {
      layer: 'policia_rodoviaria_pto_p31982',
      tab: 'Polícia Rodoviária',
      headers: [
        { text: 'Nome', value: 'nome' }
      ],
      items: []
    },
    {
      layer: 'balsas_pto_p31982',
      tab: 'Balsas',
      headers: [
        { text: 'Nome', value: 'nome' }
      ],
      items: []
    },
    {
      layer: 'portos_pto_p31982',
      tab: 'Portos',
      headers: [
        { text: 'Nome', value: 'nome' }
      ],
      items: []
    },
    {
      layer: 'aeroportos_pto_p31982',
      tab: 'Aeroportos',
      headers: [
        { text: 'Nome', value: 'nome' }
      ],
      items: []
    },
    {
      layer: 'povoados_pto_p31982',
      tab: 'Povoados',
      headers: [
        { text: 'Nome', value: 'comment' }
      ],
      items: []
    },
    {
      layer: 'cidades_pto_p31982',
      tab: 'Cidades',
      headers: [
        { text: 'Nome', value: 'nome_rotu' }
      ],
      items: []
    },
    {
      layer: 'superintendencias_pol_p31982',
      tab: 'Superintendências',
      headers: [
        { text: 'Superintendência', value: 'sup' }
      ],
      items: []
    },
    {
      layer: 'pontos_inicio_fim_pto_p4674_a2019',
      tab: 'Pontos de Início e Fim',
      headers: [
        { text: 'Referência', value: 'referencia' }
      ],
      items: []
    },
    {
      layer: 'pedagio_pto_p31982',
      tab: 'Pedágio',
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        //{ text: 'Município', value: 'municipio' },
        { text: 'Tipo', value: 'tipo' }
      ],
      items: []
    },
    {
      layer: 'cop_lin_p31982',
      tab: 'COP',
      headers: [
        { text: 'Trecho', value: 'trecho' },
        { text: 'Programa', value: 'programa' },
        { text: 'Lote', value: 'lote' },
        { text: 'Contrato', value: 'contrato' },
        { text: 'Empresa', value: 'empresa' },
        { text: 'Gerente', value: 'gerente' },
        autenticacao ? {text: 'Link', value: 'link' } : {}
      ],
      items: []
    },
    {
      layer: 'cremep_lin_p31982',
      tab: 'CREMEP',
      headers: [
        { text: 'Trecho', value: 'trecho' },
        { text: 'Programa', value: 'programa' },
        { text: 'Lote', value: 'lote' },
        { text: 'Contrato', value: 'contrato' },
        { text: 'Empresa', value: 'empresa' },
        { text: 'Gerente', value: 'gerente' },
        autenticacao ? {text: 'Link', value:  'link' } : {}
      ],
      items: []
    },
    {
      layer: 'faixa_dominio_lin_p31982',
      tab: 'Faixa de Domínio',
      headers: [
        { text: 'Trecho', value: 'trecho' },
        { text: 'Programa', value: 'programa' },
        { text: 'Lote', value: 'lote' },
        { text: 'Contrato', value: 'contrato' },
        { text: 'Gerente', value: 'gerente'},
        { text: 'Empresa', value: 'empresa' },
        autenticacao ? {text: 'Link', value:  'link' } : {}
      ],
      items: []
    },
    {
      layer: 'dispensas_licitacao_lin_p31982',
      tab: 'Demais Contratos',
      headers: [
        { text: 'Trecho', value: 'trecho' },
        { text: 'Contrato', value: 'contrato' },
        { text: 'Gerente', value: 'gerente'},
        { text: 'Lote', value: 'lote' },
        { text: 'Empresa', value: 'empresa' },
        autenticacao ? {text: 'Link', value:  'link' } : {}
      ],
      items: []
    },
    {
      layer: 'anel_integracao_lin_p31982',
      tab: 'Anel de Integração',
      headers: [
        { text: 'Rodovia', value: 'name' },
        { text: 'Concessão', value: 'concessao' }
      ],
      items: []
    },
    {
      layer: 'area_de_gestao_lin_p31982',
      tab: 'Áreas de Gestão',
      headers: [
        { text: 'Extensão (km)', value: 'extensao' },
        { text: 'Código S.R.E', value: 'codtrecho' },
        { text: 'Área', value: 'area2020' },
        { text: 'Gerente', value: 'gerente' },
        { text: 'Contato', value: 'contato' }
      ],
      items: []
    },
    {
      layer: 'pontes_pto_p31982',
      tab: 'Pontes',
      headers: [
        {text: 'Obra de Arte Especial', value: 'nome_oae'},
        {text: 'Largura', value: 'largura'},
        {text: 'Comprimento', value: 'comp'}
      ],
      items: []
    },
    {
      layer: 'restricao_trafego_lin_p31982',
      tab: 'Restrição de Tŕafego',
      headers: [
        {text: 'Código S.R.E', value: 'codtrecho'},
        {text: 'Limite', value: 'limite'},
        {text: 'Rodovia', value: 'rodovia'},
        {text: 'Restrição', value: 'restricao'},
        {text: 'Portaria', value: 'port_der'},
        {text: 'Link', value: 'link_port'},
        {text: 'Superintendência', value: 'sup'}
      ],
      items: []
    },
    {
      layer: 'novo_prog_conservacao_lin_p31982',
      tab: 'PROCONSERVA',
      headers: [
        {text: 'SRE', value: 'sre'},
        {text: 'Contrato', value: 'contrato'},
        {text: 'Gerente', value: 'gerente'},
        {text: 'Lote', value: 'lote'},
        {text: 'Empresa', value: 'empresa'},
        autenticacao ? {text: 'Link', value: 'link' } : {}
      ],
      items: []
    },
    {
      layer: 'cons_antigo_anel_lin_p31982',
      tab: 'Antigo Anel - IntegraParaná',
      headers:  [
        {text: 'SRE', value: 'sre'},
        {text: 'Contrato', value: 'contrato'},
        {text: 'Gerente', value: 'gerente'},
        {text: 'Lote', value: 'sup'},
        {text: 'Ext (km)', value: 'extensao'},
        {text: 'Empresa', value: 'empresa'},
        autenticacao ? {text: 'Link', value: 'link' } : {}
      ],
      items: []
    },
    {
      layer: 'condicao_malha_lin_p31982',
      tab: 'Condição da Malha Rodoviária Pavimentada (2022)',
      headers: [
        {text: 'Trecho', value: 'trecho'},
        {text: 'Km do trecho', value: 'ordem'},
        {text: 'Nota', value: 'nota'},
        {text: 'Comentário', value: 'coment'},
        {text: 'Data do levantamento', value: 'data_lev'}
      ],
      items: []
    },
    {
      layer: 'obras_dt_lin_p31982',
      tab: 'Obras Diretoria Técnica',
      headers: [
        {text: 'Rodovia', value: 'rodovia'},
        {text: 'Contrato',value: 'contrato'},
        {text: 'Objeto',  value: 'objeto'},
        {text: 'Trecho',  value: 'trecho'},
        {text: 'Extensão (km)',value: 'extensao'},
        autenticacao ? {text: 'Link', value: 'link' } : {}
      ],
      items: []
    },
    {
      layer: 'projetos_dt_lin_p31982',
      tab: 'Projetos Diretoria Técnica',
      headers: [
        {text: 'Rodovia',   value: 'rodovia'},
        {text: 'Contrato',  value: 'contrato'},
        {text: 'Objeto',    value: 'objeto'},
        {text: 'Projetista',value: 'projetis'},
        {text: 'Trecho',    value: 'trecho'},
        {text: 'Extensão (km)',  value: 'extensao'},
        autenticacao ? {text: 'Link', value: 'link' } : {}
      ],
      items: []
    },
    {
      layer: 'pista_servicos_lin_p31982',
      tab: 'Conservação da Pista',
      headers: [
        {text: 'Programação de serviços para a semana',   value: 'data'},
        {text: 'Código S.R.E',  value: 'cod_trecho'},
        {text: 'Trecho',    value: 'trecho'},
        {text: 'EXT (km)',  value: 'ext'},
        {text: 'Contrato',  value: 'contrato'},
        {text: 'Gerente',   value: 'gerente_c'},
        {text: 'Empresa',   value: 'empresa'},
        {text: 'Programa',  value: 'programa'},      
        {text: 'Serviços Programados',  value: 'descricao'},
        {text: 'Situação',    value: 'situacao'},
        {text: 'Data de Início',  value: 'data_inic'},
        {text: 'Previsão de Data de término',  value: 'data_term'}
      ],
      items: []
    },
    {
      layer: 'faixa_servicos_lin_p31982',
      tab: 'Faixa Domínio',
      headers: [
        {text: 'Programação de serviços para a semana',   value: 'data'},
        {text: 'Código S.R.E',  value: 'cod_trecho'},
        {text: 'Trecho',  value: 'trecho'},
        {text: 'EXT (km)',value: 'ext'},
        {text: 'Contrato',value: 'contrato'},
        {text: 'Gerente', value: 'gerente_co'},
        {text: 'Empresa', value: 'empresa'},
        {text: 'Programa',value: 'programa'},      
        {text: 'Serviços Programados',  value: 'descricao'},
        {text: 'Situação',    value: 'situacao'},
        {text: 'Data de Início',  value: 'data_inici'},
        {text: 'Previsão de Data de término',  value: 'data_termi'}
      ],
      items: []
    },
    {
      layer: 'proseg_servicos_lin_p31982',
      tab: 'Proseg',
      headers: [
        {text: 'Programação de serviços para a semana',   value: 'data'},
        {text: 'Código S.R.E',  value: 'cod_trecho'},
        {text: 'Trecho',  value: 'trecho'},
        {text: 'EXT (km)',value: 'ext'},
        {text: 'Contrato',value: 'contrato'},
        {text: 'Gerente', value: 'gerente_c'},
        {text: 'Empresa', value: 'empresa'},
        {text: 'Programa',value: 'programa'},      
        {text: 'Serviços Programados',  value: 'descricao'},
        {text: 'Situação',    value: 'situacao'},
        {text: 'Data de Início',  value: 'data_inic'},
        {text: 'Previsão de Data de término',  value: 'data_term'}
      ],
      items: []
    }  
  ]
    return templates
}
/*
export let templates = [
  {
    layer: 'sistema_rodoviario_lin_p31982',
    tab: 'Sistema Rodoviário',
    headers: [
      { text: 'Trecho', value: 'trecho' },
      { text: 'De', value: 'de' },
      { text: 'Para', value: 'para' },
      { text: 'Km Inicial', value: 'km_inicial' },
      { text: 'Km Final', value: 'km_final' },
      { text: 'Extensão (km)', value: 'extensao' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Responsável', value: 'resp' },
      { text: 'Escritório Regional', value: 'esc_regional' },
      { text: 'Jurisdição', value: 'jurisdicao' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Tipojuris', value: 'tipojuris' }
    ],
    items: []
  },
  {
    layer: 'escritorios_regionais_pol_p31982',
    tab: 'Escritórios Regionais',
    headers: [
      { text: 'Escritório Regional', value: 'esc_reg' },
      { text: 'Superintendência', value: 'sup' }
    ],
    items: []
  },
  {
    layer: 'municipios_pol_p31982',
    tab: 'Municípios',
    headers: [
      { text: 'Nome', value: 'nome' }
    ],
    items: []
  },
  {
    layer: 'policia_rodoviaria_pto_p31982',
    tab: 'Polícia Rodoviária',
    headers: [
      { text: 'Nome', value: 'nome' }
    ],
    items: []
  },
  {
    layer: 'balsas_pto_p31982',
    tab: 'Balsas',
    headers: [
      { text: 'Nome', value: 'nome' }
    ],
    items: []
  },
  {
    layer: 'portos_pto_p31982',
    tab: 'Portos',
    headers: [
      { text: 'Nome', value: 'nome' }
    ],
    items: []
  },
  {
    layer: 'aeroportos_pto_p31982',
    tab: 'Aeroportos',
    headers: [
      { text: 'Nome', value: 'nome' }
    ],
    items: []
  },
  {
    layer: 'povoados_pto_p31982',
    tab: 'Povoados',
    headers: [
      { text: 'Nome', value: 'comment' }
    ],
    items: []
  },
  {
    layer: 'cidades_pto_p31982',
    tab: 'Cidades',
    headers: [
      { text: 'Nome', value: 'nome_rotu' }
    ],
    items: []
  },
  {
    layer: 'superintendencias_pol_p31982',
    tab: 'Superintendências',
    headers: [
      { text: 'Superintendência', value: 'sup' }
    ],
    items: []
  },
  {
    layer: 'pontos_inicio_fim_pto_p4674_a2019',
    tab: 'Pontos de Início e Fim',
    headers: [
      { text: 'Referência', value: 'referencia' }
    ],
    items: []
  },
  {
    layer: 'pedagio_pto_p31982',
    tab: 'Pedágio',
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Telefone', value: 'telefone' },
      //{ text: 'Município', value: 'municipio' },
      { text: 'Tipo', value: 'tipo' }
    ],
    items: []
  },
  {
    layer: 'cop_lin_p31982',
    tab: 'COP',
    headers: [
      { text: 'Trecho', value: 'trecho' },
      { text: 'Programa', value: 'programa' },
      { text: 'Lote', value: 'lote' },
      { text: 'Contrato', value: 'contrato' },
      { text: 'Empresa', value: 'empresa' },
      { text: 'Gerente', value: 'gerente' },
      autenticado() ? {text: 'Link', value: 'link' } : {}
    ],
    items: []
  },
  {
    layer: 'cremep_lin_p31982',
    tab: 'CREMEP',
    headers: [
      { text: 'Trecho', value: 'trecho' },
      { text: 'Programa', value: 'programa' },
      { text: 'Lote', value: 'lote' },
      { text: 'Contrato', value: 'contrato' },
      { text: 'Empresa', value: 'empresa' },
      { text: 'Gerente', value: 'gerente' },
      autenticado() ? {text: 'Link', value:  'link' } : {}
    ],
    items: []
  },
  {
    layer: 'faixa_dominio_lin_p31982',
    tab: 'Faixa de Domínio',
    headers: [
      { text: 'Trecho', value: 'trecho' },
      { text: 'Programa', value: 'programa' },
      { text: 'Lote', value: 'lote' },
      { text: 'Contrato', value: 'contrato' },
      { text: 'Gerente', value: 'gerente'},
      { text: 'Empresa', value: 'empresa' },
      autenticado() ? {text: 'Link', value:  'link' } : {}
    ],
    items: []
  },
  {
    layer: 'anel_integracao_lin_p31982',
    tab: 'Anel de Integração',
    headers: [
      { text: 'Rodovia', value: 'name' },
      { text: 'Concessão', value: 'concessao' }
    ],
    items: []
  },
  {
    layer: 'area_de_gestao_lin_p31982',
    tab: 'Áreas de Gestão',
    headers: [
      { text: 'Extensão (km)', value: 'extensao' },
      { text: 'Código S.R.E', value: 'codtrecho' },
      { text: 'Área', value: 'area2020' },
      { text: 'Gerente', value: 'gerente' },
      { text: 'Contato', value: 'contato' }
    ],
    items: []
  },
  {
    layer: 'pontes_pto_p31982',
    tab: 'Pontes',
    headers: [
      {text: 'Obra de Arte Especial', value: 'nome_oae'},
      {text: 'Largura', value: 'largura'},
      {text: 'Comprimento', value: 'comp'}
    ],
    items: []
  },
  {
    layer: 'restricao_trafego_lin_p31982',
    tab: 'Restrição de Tŕafego',
    headers: [
      {text: 'Código S.R.E', value: 'codtrecho'},
      {text: 'Limite', value: 'limite'},
      {text: 'Rodovia', value: 'rodovia'},
      {text: 'Restrição', value: 'restricao'},
      {text: 'Portaria', value: 'port_der'},
      {text: 'Link', value: 'link_port'},
      {text: 'Superintendência', value: 'sup'}
    ],
    items: []
  },
  {
    layer: 'novo_prog_conservacao_lin_p31982',
    tab: 'PROCONSERVA',
    headers: [
      {text: 'SRE', value: 'sre'},
      {text: 'Contrato', value: 'contrato'},
      {text: 'Gerente', value: 'gerente'},
      {text: 'Lote', value: 'lote'},
      {text: 'Empresa', value: 'empresa'},
      autenticado() ? {text: 'Link', value: 'link' } : {}
    ],
    items: []
  },
  {
    layer: 'cons_antigo_anel_lin_p31982',
    tab: 'Antigo Anel - IntegraParaná',
    headers:  [
      {text: 'SRE', value: 'sre'},
      {text: 'Contrato', value: 'contrato'},
      {text: 'Gerente', value: 'gerente'},
      {text: 'Lote', value: 'sup'},
      {text: 'Ext (km)', value: 'extensao'},
      {text: 'Empresa', value: 'empresa'},
      autenticado() ? {text: 'Link', value: 'link' } : {}
    ],
    items: []
  },
  {
    layer: 'condicao_malha_lin_p31982',
    tab: 'Condição da Malha Rodoviária Pavimentada (2022)',
    headers: [
      {text: 'Trecho', value: 'trecho'},
      {text: 'Km do trecho', value: 'ordem'},
      {text: 'Nota', value: 'nota'},
      {text: 'Comentário', value: 'coment'},
      {text: 'Data do levantamento', value: 'data_lev'}
    ],
    items: []
  },
  {
    layer: 'obras_dt_lin_p31982',
    tab: 'Obras Diretoria Técnica',
    headers: [
      {text: 'Rodovia', value: 'rodovia'},
      {text: 'Contrato',value: 'contrato'},
      {text: 'Objeto',  value: 'objeto'},
      {text: 'Trecho',  value: 'trecho'},
      {text: 'Extensão (km)',value: 'extensao'},
      autenticado() ? {text: 'Link', value: 'link' } : {}
    ],
    items: []
  },
  {
    layer: 'projetos_dt_lin_p31982',
    tab: 'Projetos Diretoria Técnica',
    headers: [
      {text: 'Rodovia',   value: 'rodovia'},
      {text: 'Contrato',  value: 'contrato'},
      {text: 'Objeto',    value: 'objeto'},
      {text: 'Projetista',value: 'projetis'},
      {text: 'Trecho',    value: 'trecho'},
      {text: 'Extensão (km)',  value: 'extensao'},
      autenticado() ? {text: 'Link', value: 'link' } : {}
    ],
    items: []
  },
  {
    layer: 'pista_servicos_lin_p31982',
    tab: 'Conservação da Pista',
    headers: [
      {text: 'Programação de serviços para a semana',   value: 'data'},
      {text: 'Código S.R.E',  value: 'cod_trecho'},
      {text: 'Trecho',    value: 'trecho'},
      {text: 'EXT (km)',  value: 'ext'},
      {text: 'Contrato',  value: 'contrato'},
      {text: 'Gerente',   value: 'gerente_c'},
      {text: 'Empresa',   value: 'empresa'},
      {text: 'Programa',  value: 'programa'},      
      {text: 'Serviços Programados',  value: 'descricao'},
      {text: 'Situação',    value: 'situacao'},
      {text: 'Data de Início',  value: 'data_inic'},
      {text: 'Previsão de Data de término',  value: 'data_term'}
    ],
    items: []
  },
  {
    layer: 'faixa_servicos_lin_p31982',
    tab: 'Faixa Domínio',
    headers: [
      {text: 'Programação de serviços para a semana',   value: 'data'},
      {text: 'Código S.R.E',  value: 'cod_trecho'},
      {text: 'Trecho',  value: 'trecho'},
      {text: 'EXT (km)',value: 'ext'},
      {text: 'Contrato',value: 'contrato'},
      {text: 'Gerente', value: 'gerente_co'},
      {text: 'Empresa', value: 'empresa'},
      {text: 'Programa',value: 'programa'},      
      {text: 'Serviços Programados',  value: 'descricao'},
      {text: 'Situação',    value: 'situacao'},
      {text: 'Data de Início',  value: 'data_inici'},
      {text: 'Previsão de Data de término',  value: 'data_termi'}
    ],
    items: []
  },
  {
    layer: 'proseg_servicos_lin_p31982',
    tab: 'Proseg',
    headers: [
      {text: 'Programação de serviços para a semana',   value: 'data'},
      {text: 'Código S.R.E',  value: 'cod_trecho'},
      {text: 'Trecho',  value: 'trecho'},
      {text: 'EXT (km)',value: 'ext'},
      {text: 'Contrato',value: 'contrato'},
      {text: 'Gerente', value: 'gerente_c'},
      {text: 'Empresa', value: 'empresa'},
      {text: 'Programa',value: 'programa'},      
      {text: 'Serviços Programados',  value: 'descricao'},
      {text: 'Situação',    value: 'situacao'},
      {text: 'Data de Início',  value: 'data_inic'},
      {text: 'Previsão de Data de término',  value: 'data_term'}
    ],
    items: []
  }
]*/
